import React, { useEffect, useState } from 'react'
import './Navbar.css'
import logo from '../../assets/logo.png'
import mune_icon from '../../assets/menu-icon.png'
import { Link } from 'react-scroll';

const Navbar = () => {
  
  const [sticky, setSticky] = useState(false);
  useEffect(()=>{
    window.addEventListener('scroll',()=>{
      window.scrollY > 50 ? setSticky(true) : setSticky(false);
    })
  },[])
  const [mobileMenu, setMobileMenu] = useState(false);
  const toggleMenu = ()=>{
          mobileMenu ? setMobileMenu(false) : setMobileMenu(true);
  }
  
  return (
    <nav className={`container ${sticky? 'dark-nav' : ''}`}>
        <img src={logo} alt='' className='logo'/>
        <ul className={mobileMenu?'': 'mobile-menu'}>
            <li><Link to='hero' smooth={true} offset={0} duration={500}>Home</Link></li>  
            <li><Link to='programs' smooth={true} offset={-260} duration={500}>Services</Link></li>  
            <li><Link to='about' smooth={true} offset={-150} duration={500}>About Us</Link></li>  
            <li><Link to='campus' smooth={true} offset={-260} duration={500}>Campus</Link></li>  
            <li><Link to='testimonils' smooth={true} offset={-260} duration={500}>Testimonials</Link></li>  
            <li><Link to='cantact' smooth={true} offset={-260} duration={500} className='btn'>Contact us</Link></li>    
                    
        </ul>
        <img src={mune_icon} alt="" className='mune-icon' onClick={toggleMenu}/>
    </nav>
  )
}

export default Navbar
